import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { DashboardFooter } from './DashboardFooter'

// CHECKPOINT: PRD-10 FR-10.1.4 — Responsive layout: sidebar margin only on desktop
export function Layout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="min-h-screen bg-background">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <TopBar
        onMenuClick={() => setMobileOpen(true)}
        sidebarCollapsed={sidebarCollapsed}
      />
      <main
        data-testid="layout-main"
        className={cn(
          'pt-20 px-4 pb-6 min-h-[calc(100vh-56px)] transition-all duration-300',
          sidebarCollapsed ? 'md:ml-[68px]' : 'md:ml-[240px]'
        )}
      >
        <div className="max-w-[1200px] mx-auto animate-fade-in">
          <Outlet />
        </div>
      </main>
      <div className={cn('transition-all duration-300', sidebarCollapsed ? 'md:ml-[68px]' : 'md:ml-[240px]')}>
        <DashboardFooter />
      </div>
    </div>
  )
}
